module.exports = __webpack_public_path__ + "static/media/logo-freshworks-landscape-1.29660022.svg";